export default __webpack_public_path__ + "static/media/arrow-left-double.42e9787a.svg";